<template>
    <div class="contentGroup">

        <div class="title chatsTitle">
            <button @click="$emit('close')" class="default small reverse backBtn"><i class="fas fa-arrow-left"></i></button>
            <h2>{{ selectedChat.name }}</h2>
        </div>

        <div class="listOfMessages">
            <div class="scrollableMessages" id="listOfMessages">
                <div class="messagesGroup">
                    <div :key="item._id" v-for="(item, key) of messages">
                        <div v-if="showDate(key)" class="messageDate">
                            <button class="default small round reverse">{{ getDayDate(item.date) }}</button>
                        </div>
                        <Message :showTime="showTime(key)" :showSeen="showSeen(key)" :message="item"/>
                    </div>
                </div>
            </div>
        </div>

        <div class="messageForm">
            <textarea class="messageInput" ref="messageInput" v-model.trim="body.message" placeholder="Write a message..."></textarea>
            <button class="default round small" @click="sendMessage"><i class="fas fa-paper-plane"></i></button>
        </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Message from './Message.vue'

    export default {
        props: ['selectedChat'],
        components: {
            Message
        },
        data() {
            return {
                body: {
                    message: '',
                    to: this.selectedChat._id,
                },
                messages: []
            }
        },
        computed: {
            ...mapGetters(['webSocket']),
        },
        methods: {
            getDayDate(date) {
                date = new Date(date);
                let year = date.getFullYear();
                let month = date.getMonth();
                let day = date.getDate();

                let today = new Date();
                today.setHours(0);
                today.setMinutes(0);
                today.setSeconds(0);
                today.setMilliseconds(0);
                let compDate = new Date(year, month, day); // month - 1 because January == 0
                let diff = today.getTime() - compDate.getTime(); // get the difference between today(at 00:00:00) and the date
                if (compDate.getTime() == today.getTime()) {
                    return "Today";
                } else if (diff <= (24 * 60 * 60 *1000)) {
                    return "Yesterday";
                } else { 
                    return compDate.toDateString(); // or format it what ever way you want
                }

            },
            showDate(key) {
                if(!this.messages[key - 1]) return true;

                let current = new Date(this.messages[key].date);
                let prev = new Date(this.messages[key - 1].date);
                if(prev.getDate() != current.getDate() 
                || prev.getMonth() != current.getMonth()
                || prev.getFullYear() != current.getFullYear()) return true;

                return false;
            },
            addEnterListeners(e) {
                // Get the code of pressed key
                const keyCode = e.which || e.keyCode;

                // 13 represents the Enter key
                if (keyCode === 13 && !e.shiftKey) {
                    // Don't generate a new line
                    e.preventDefault();
                    this.sendMessage();
                }
            },
            showTime(key) {
                if(!this.messages[key + 1]) return true;
                if(this.messages[key].from != this.messages[key + 1].from) return true;
                return false;
            },
            showSeen(key) {
                if(!this.messages[key + 1]) return true;
                if(this.messages[key].from == this.messages[key + 1].from) {
                    if(this.messages[key].seen == this.messages[key + 1].seen) return false;
                    return true;
                }
                return true;
            },
            updateScroll(){
                var element = document.getElementById("listOfMessages");
                element.scrollTop = element.scrollHeight;
            },
            async sendMessage() {
                await this.$axios.post('/chats/newMessage', this.body)
                .then(data => {
                    this.body.message = "";
                })
                .catch(err => {
                    console.log("error");
                });

                setTimeout(this.updateScroll, 100);
            },
            markAllAsSeen() {
                this.webSocket.send('markChatAsSeen', {
                    chat: this.selectedChat._id
                });
                for(const item of this.messages) {
                    if(item.to == this.user._id) {
                        item.seen = true;
                    }
                }
            },
            markMessagesAsSeen() {
                for(const item of this.messages) {
                    item.seen = true;
                }
            },
            getMessages() {
                this.$axios.get(`/chat/${this.selectedChat._id}`)
                .then(data => {
                    this.messages = data.data;
                    this.markAllAsSeen();
                    setTimeout(this.updateScroll, 100);
                });
            },
            addWebSocketListener() {
                if(!this.webSocket) return;
                this.webSocket.on('newMessage', (body) => {

                    if(body.to == this.body.to && body.from == this.user._id 
                    || body.from == this.body.to && body.to == this.user._id) {
                        this.messages.push(body);
                        setTimeout(() => {
                            this.updateScroll();
                            this.markAllAsSeen();
                        }, 100);
                    }
                    
                });

                this.webSocket.on('markChatAsSeen', (body) => {
                    this.markMessagesAsSeen();
                });
            },
        },
        beforeUnmount() {
            this.webSocket.remove('newMessage');
            this.webSocket.remove('markChatAsSeen');
            this.$refs['messageInput'].removeEventListener('keydown', this.addEnterListeners);
        },
        mounted() {
            this.getMessages();
            this.addWebSocketListener();
            // document.body.addEventListener('keydown', this.addEnterListeners);
            this.$refs['messageInput'].addEventListener('keydown', this.addEnterListeners);
        },
        watch: {
            webSocket() {
                this.addWebSocketListener();
            }
        }
    }
</script>

<style lang="scss" scoped>
.chatsTitle {
    padding: 30px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid $borderColor;
    width: 100%;
    z-index: 2;
    background: $bg;
    .backBtn {
        margin-right: 20px;
    }
}

.listOfMessages {
    width: 100%;
    max-width: 100%;
    position: relative;
    .scrollableMessages {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
    }
}

.messagesGroup {
    padding: 20px;
    display: grid;
    align-items: end;
    align-content: end;
    row-gap: 10px;
}

.messageForm {
    padding: 20px;
    border-top: 1px solid $borderColor;
    display: grid;
    grid-template-columns: minmax(0, 1fr) 50px;
    align-items: start;
    align-content: start;
    background: $bg;
    .messageInput {
        width: 100%;
        min-height: 40px;
        background: transparent;
        border: 0;
        resize: none;
    }
}

.contentGroup {
    display: grid;
    height: 100%;
    width: 100%;
    grid-template-rows: auto minmax(0, 1fr) auto;
}

.messageDate {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    position: sticky;
    top: 10px;
}

</style>